import * as React from "react";
import { ContractNote } from "../../../assets/svg/ContractNote";
import { IdStyles } from "../../../less/IdStyles";
import { SvgButton } from "../svg-button/SvgButton";
export var GridItemContainerContract = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick;
    return (React.createElement(SvgButton, { name: IdStyles.MarketGridItemContract, svg: ContractNote, className: className, onClick: onClick }, children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/GridItemContainerContract.tsx
// module id = 2720
// module chunks = 3